<template>
    <div>
        <router-view></router-view>
        <link href="css/bootstrap.css" rel="stylesheet">
        <link href="css/font-awesome.css" rel="stylesheet">
        <link href="css/StyleSheet.css" rel="stylesheet">
        <link href="css/PagedList.css" rel="stylesheet">
    </div>
</template>

<script>
    export default {
    }
</script>

<style>
    #app {
        font-family: Avenir, Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }
</style>
